<template>
    <div class="wrapper wrapper-content">
        <div class="row">
            <div class="ibox float-e-margins">
                <div class="ibox-content">
                    <div class="row" style="margin-bottom: 10px">
                        <div class="col-sm-5 m-b-xs">
                            <el-button type="primary" @click="createArticle">新建</el-button>
                        </div>
                        <div class="col-sm-4 m-b-xs">
                        </div>
                        <!--<div class="col-sm-3">-->
                        <!--<div class="input-group">-->
                        <!--<input type="text" placeholder="请输入关键词" class="input-sm form-control">-->
                        <!--<span class="input-group-btn">-->
                        <!--<button type="button" class="btn btn-sm btn-primary"> 搜索</button>-->
                        <!--</span>-->
                        <!--</div>-->
                        <!--</div>-->
                    </div>
                    <div class="row">
                        <div class="col-sm-12 m-b-xs">
                            <el-table :data="tableData" border style="width: 100%">
                                <el-table-column prop="id" label="#"></el-table-column>
                                <el-table-column label="类型名称" width="800">
                                    <template slot-scope="scope">
                                        <!--<font :style="scope.row.levelStyle"> |-&#45;&#45; </font>-->
                                        {{scope.row.name}}
                                    </template>
                                </el-table-column>

                                <el-table-column prop="creatData" label="创建时间"></el-table-column>
                                <el-table-column prop="updateData" label="更新时间"></el-table-column>
                                <el-table-column label="操作"  width="144">
                                    <template slot-scope="scope">
                                        <el-button @click="detailItem(scope.row)" size="small">查看</el-button>
                                        <el-button type="danger" @click="deleteItem(scope.row)" size="small">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { categoryList,deleteCategory } from '@/services/category'

    export default {
      name: 'CategoryListPage' ,
      data() {
        return {
          tableData: []
        }
      },
      mounted() {
        this.getArticleList();
      },
      methods: {
        timeStampToStr(date){
          var timestamp = new Date(date*1000);//直接用 new Date(时间戳) 格式转化获得当前时间
          var timeDate = timestamp.toLocaleDateString().replace(/\//g, "-") + " " + timestamp.toTimeString().substr(0, 8);
          return timeDate;
        },
        createArticle(){
          this.$router.push('creatCategory');
        },
        getArticleList(){
          categoryList().then(res => {
            let list = res.items;
            for(var i in list){
              list[i].creatData = this.timeStampToStr(list[i].created_at );
              list[i].updateData = this.timeStampToStr(list[i].updated_at );
              if (list[i].pid > 1) {
                list[i].levelStyle = 'padding-left: '+(list[i].pid - 1) * 50+'px;'
              }else {
                list[i].levelStyle = 'padding-left: 0px;display: none;'
              }

            }
            this.tableData = list;
          }).catch(error => {});
        },
        detailItem(row){
          let uid = row.uid;
          this.$router.push('categoryDetail/'+uid);
        },
        deleteItem(row) {
          let uid = row.uid;
          this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            deleteCategory({id:uid}).then(res => {
              if (res.code == 0) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success'
                });
                this.getArticleList();
              }
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });

        },
      }
    }
</script>

<style scoped>

</style>
